import async from '~/utils/async';
import resolver from './PageEditLayout.resolver';
import PageEditLayout from './PageEditLayout';

export default async(resolver)(PageEditLayout);
